// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heatmap-container {
    padding: 20px;
    background-color: #f9f9f9;
}

.heatmap-header {
    margin-bottom: 15px;
}

.section-icon {
    margin-right: 10px;
}

.heatmap-subtitle {
    background-color: #fff3cd;
    color: #664d03;
    padding: 10px;
    border-left: 4px solid #ffc107;
    font-size: 0.95rem;
    margin-top: 10px;
    border-radius: 4px;
}

.emirate-filters {
    margin: 10px 0 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.emirate-chip {
    background: #efefef;
    border: none;
    padding: 6px 14px;
    border-radius: 25px;
    cursor: pointer;
    transition: background 0.2s ease;
    font-weight: 500;
}

    .emirate-chip:hover {
        background: #ddd;
    }

    .emirate-chip.selected {
        background: #111;
        color: #fff;
    }

.heatmap-grid {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.heatmap-header-row,
.heatmap-row {
    display: flex;
    font-weight: bold;
}

.col-emirate {
    flex: 1.5 1;
    padding: 10px;
    border: 1px solid #ddd;
    background: #fafafa;
}

.col-risk {
    flex: 1 1;
    padding: 10px;
    border: 1px solid #ddd;
    text-align: center;
}

.risk-label {
    font-weight: bold;
}

.risk-desc {
    font-size: 0.8rem;
    color: #FFF;
}

.risk-critical {
    background: #7a0000;
    color: #fff;
}

.risk-high {
    background: #f44336;
    color: #fff;
}

.risk-low {
    background-color: #2db7a3;
    color: #003c3c; 
    font-weight: bold;
    text-align: center;
    padding: 10px;
}

.risk-medium {
    background-color: #f2c744;
    color: #2d2d2d;
    font-weight: bold;
    text-align: center;
    padding: 10px;
}

.risk-none {
    background: #cfd8dc;
    color: #333;
}

.ai-insight-box {
    background: #f0f8ff;
    border-left: 5px solid #2196f3;
    padding: 12px 18px;
    font-size: 0.9rem;
    margin-bottom: 18px;
    margin-top: -1px;
}

    .ai-insight-box ul {
        margin: 8px 0 0;
        padding-left: 20px;
    }

.ai-insight-title {
    display: flex;
    align-items: center;
    font-size: 1rem;
    color: #0d47a1;
    font-weight: 600;
}

.ai-icon {
    margin-right: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/RiskTargetingHeatmap.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;IAEI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;AAEJ;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;;IAEI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;IAEI;QACI,eAAe;QACf,kBAAkB;IACtB;;AAEJ;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".heatmap-container {\n    padding: 20px;\n    background-color: #f9f9f9;\n}\n\n.heatmap-header {\n    margin-bottom: 15px;\n}\n\n.section-icon {\n    margin-right: 10px;\n}\n\n.heatmap-subtitle {\n    background-color: #fff3cd;\n    color: #664d03;\n    padding: 10px;\n    border-left: 4px solid #ffc107;\n    font-size: 0.95rem;\n    margin-top: 10px;\n    border-radius: 4px;\n}\n\n.emirate-filters {\n    margin: 10px 0 20px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.emirate-chip {\n    background: #efefef;\n    border: none;\n    padding: 6px 14px;\n    border-radius: 25px;\n    cursor: pointer;\n    transition: background 0.2s ease;\n    font-weight: 500;\n}\n\n    .emirate-chip:hover {\n        background: #ddd;\n    }\n\n    .emirate-chip.selected {\n        background: #111;\n        color: #fff;\n    }\n\n.heatmap-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.heatmap-header-row,\n.heatmap-row {\n    display: flex;\n    font-weight: bold;\n}\n\n.col-emirate {\n    flex: 1.5;\n    padding: 10px;\n    border: 1px solid #ddd;\n    background: #fafafa;\n}\n\n.col-risk {\n    flex: 1;\n    padding: 10px;\n    border: 1px solid #ddd;\n    text-align: center;\n}\n\n.risk-label {\n    font-weight: bold;\n}\n\n.risk-desc {\n    font-size: 0.8rem;\n    color: #FFF;\n}\n\n.risk-critical {\n    background: #7a0000;\n    color: #fff;\n}\n\n.risk-high {\n    background: #f44336;\n    color: #fff;\n}\n\n.risk-low {\n    background-color: #2db7a3;\n    color: #003c3c; \n    font-weight: bold;\n    text-align: center;\n    padding: 10px;\n}\n\n.risk-medium {\n    background-color: #f2c744;\n    color: #2d2d2d;\n    font-weight: bold;\n    text-align: center;\n    padding: 10px;\n}\n\n.risk-none {\n    background: #cfd8dc;\n    color: #333;\n}\n\n.ai-insight-box {\n    background: #f0f8ff;\n    border-left: 5px solid #2196f3;\n    padding: 12px 18px;\n    font-size: 0.9rem;\n    margin-bottom: 18px;\n    margin-top: -1px;\n}\n\n    .ai-insight-box ul {\n        margin: 8px 0 0;\n        padding-left: 20px;\n    }\n\n.ai-insight-title {\n    display: flex;\n    align-items: center;\n    font-size: 1rem;\n    color: #0d47a1;\n    font-weight: 600;\n}\n\n.ai-icon {\n    margin-right: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
